module.exports = __webpack_public_path__ + "img/qygl.29d37ec7.jpg";